export const setSearchParam = (key: string, value: string) => {
  const params = new URLSearchParams(window.location.search);

  if (!params.get(key)) {
    params.set(key, value);
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  }
};

export const deleteSearchParam = (key: string) => {
  const params = new URLSearchParams(window.location.search);

  if (params.get(key)) {
    params.delete(key);
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  }
};

export const getSearchParam = (key: string) => {
  const params = new URLSearchParams(window.location.search);

  return params.get(key);
};
